function loaderStatusSelector(state) {
  return Boolean(state.global.loader.loadCount);
}

function loaderTextSelector(state) {
  return state.global.loader.loaderText;
}

export { loaderStatusSelector, loaderTextSelector };
